// web/src/components/common/HomeLoopVideo.jsx
import React, { useEffect, useRef, useState } from "react";

export default function HomeLoopVideo({
  mp4Src = "/media/home-promo-square.mp4",
  webmSrc = "/media/home-promo-square.webm",
  posterSrc = "/media/home-promo-square-poster.png",
  threshold = 0.35,
}) {
  const wrapRef = useRef(null);
  const videoRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [reducedMotion, setReducedMotion] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    const update = () => setReducedMotion(mq.matches);
    update();

    if (mq.addEventListener) mq.addEventListener("change", update);
    else mq.addListener(update);

    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", update);
      else mq.removeListener(update);
    };
  }, []);

  useEffect(() => {
    if (!wrapRef.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting && entry.intersectionRatio >= threshold);
      },
      { threshold: [0, threshold, 0.6, 1] }
    );

    observer.observe(wrapRef.current);
    return () => observer.disconnect();
  }, [threshold]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    if (reducedMotion || document.hidden || !isVisible) {
      video.pause();
      return;
    }

    const p = video.play();
    if (p && typeof p.catch === "function") p.catch(() => {});
  }, [isVisible, reducedMotion]);

  useEffect(() => {
    const onVisibilityChange = () => {
      const video = videoRef.current;
      if (!video) return;

      if (document.hidden || reducedMotion || !isVisible) {
        video.pause();
        return;
      }

      const p = video.play();
      if (p && typeof p.catch === "function") p.catch(() => {});
    };

    document.addEventListener("visibilitychange", onVisibilityChange);
    return () => document.removeEventListener("visibilitychange", onVisibilityChange);
  }, [isVisible, reducedMotion]);

  return (
    <section
      ref={wrapRef}
      className="home-video-section"
      aria-label="Aperçu vidéo du service"
    >
      <div className="home-video-glow" />
      <div className="home-video-frame">
        <video
          ref={videoRef}
          className="home-video-media"
          muted
          loop
          playsInline
          autoPlay
          preload="metadata"
          poster={posterSrc}
        >
          <source src={webmSrc} type="video/webm" />
          <source src={mp4Src} type="video/mp4" />
        </video>
      </div>
    </section>
  );
}